import { push } from "connected-react-router";

export type BonusMode = "view" | "details" | "edit";

const bonusList = (
  page: number,
  size: number,
  startDate?: number,
  endDate?: number,
  operatorId?: string,
  carrierId?: string,
  area?: string,
  statuses?: string[]
) => {
  let path = `/bonus?page=${page}&size=${size}`;
  if (startDate) path = `${path}&startDate=${startDate}`;
  if (endDate) path = `${path}&endDate=${endDate}`;
  if (operatorId) path = `${path}&operatorId=${operatorId}`;
  if (carrierId) path = `${path}&carrierId=${carrierId}`;
  if (area) path = `${path}&area=${area}`;
  if (statuses && statuses.length > 0) path = `${path}&statuses=${statuses.join("-")}`;
  return push(path);
};

const bonusAdd = () => push("bonus/add");

const bonusSectionView = (reportId: string, mode: BonusMode) =>
  push(`/bonus/${reportId}/${mode}`);

const bonusView = (bonusId: string) => bonusSectionView(bonusId, "view");
const bonusDetails = (bonusId: string) => bonusSectionView(bonusId, "details");
const bonusEdit = (bonusId: string) => bonusSectionView(bonusId, "edit");

export const gotoBonus = {
  bonusList: bonusList,
  bonusView: bonusView,
  bonusAdd: bonusAdd,
  bonusDetails: bonusDetails,
  bonusEdit: bonusEdit,
};
